import { FC, PropsWithChildren, ReactNode } from 'react';
import { Dialog } from './Dialog';

export type DialogBaseProps = {
  title: ReactNode;
  onClose: () => void;
  size?: 'sm' | 'default' | 'lg' | 'xl' | 'full';
  className?: string;
};

export const DialogBase: FC<PropsWithChildren<DialogBaseProps>> = ({
  title,
  children,
  onClose,
  size = 'default',
  className,
}) => {
  return (
    <Dialog title={title} onClose={onClose} size={size} className={className}>
      {children}
    </Dialog>
  );
};
